exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lead-overview-centered-image {\n  display: block;\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.lead-overview-profile-section {\n  border-radius: 11px;\n  border: solid 1px #979797;\n  padding: 10px; }\n\n.lead-overview-lead-label {\n  font-weight: bold;\n  font-size: 20px;\n  color: #4a4a4a; }\n\n.lead-overview-data-box {\n  border-radius: 8px;\n  background-color: #4a4a4a;\n  border: solid 1px #00a4e1;\n  color: #ffffff;\n  font-family: OpenSans;\n  min-height: 100px;\n  overflow-x: auto; }\n\n.lead-overview-data-box-header-text {\n  font-size: 24px; }\n\n.lead-overview-data-box-body-text {\n  font-size: 18px; }\n\n.lead-overview-extra-data-p {\n  margin: 0px 15px 4px; }\n\n.lead-overview-unknown-body {\n  color: red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!../scss/lead_overview.scss
// module id = 3502
// module chunks = 69